module.exports = __webpack_public_path__ + "img/icon-chevron-right.bc9fb2b7.svg";